<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getRoleList_data.roleName"
          placeholder="请输入角色名"

          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getRoleList

          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if='addRole'
          @click=" $form('addRole') "

          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加角色
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getRoleList'
      api='getRoleList'
      updateapi='updateRole'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addRole:    [ "新增角色信息", "el-icon-circle-plus" ],
        updateRole: [ "修改角色信息", "el-icon-edit-outline"],
        $succeed$: getRoleList
      }'
      @close='$form("addRole","reset")' >
      <!-- <hide slot='id' /> -->
    </myform>

    <myform view.updateRoleAuth='分配权限#el-icon-edit-outline#保存' id='FormTop' top='20px'
      @opened='arguments[0].title += " | @" + row.roleName'
      @close='$form("updateRoleAuth","hide")'
      @closed='getRoleAuthListByProject_data.data=[]'
      confirm="$refs.ElTree.getCheckedKeys()"
      >

      <template v-slot >
        <el-input placeholder="搜索权限名称" size='small' style='padding-left:5px;margin:-15px 0 10px;' 
          v-model="string" @input="$refs.ElTree.filter(string)" clearable
          ></el-input>
        <el-tree
          ref='ElTree'
          :data='getRoleAuthListByProject_data.data||[]'
          show-checkbox
          highlight-current
          check-on-click-node
          icon-class='el-icon-arrow-right'
          @check="Myformdata.authListString = arguments[1].halfCheckedKeys.concat(arguments[1].checkedKeys) + ''"

          node-key='authId'
          :props='{
            children: "children",
            label: "authName"
          }'
          :filter-node-method="(string,data)=>string === '' || data.authName.includes(string)"
          >
        </el-tree>
      </template>

      <hide slot='roleId' />
      <hide slot='authListString' />

    </myform>

  </div>
</template>

<script>
/*
  样例说明：
  1）所有接口支持链式调用，如 addRole('正在添加..').queryUser("正在查询..")
*/
export default {
  data() {
    return {
      roleid: null,

      tableColums_getRoleList: {
        $selection: false,

        roleName: '角色名称',
        
        createtime: '创建时间|sortable',

        roleRemark: '角色描述',

        $operation: ( this.updateRole || this.deleteRole || this.updateRoleAuth ) && [
          '操作', 200,


          this.updateRole && `@text: 编辑#success
           @click: $form("updateRole",$row)
          `,

          this.deleteRole && `@text: 删除#danger
           @click: _confirm('确定要删除该角色吗?')
                   .trigger('deleteRole',{roleId:$row.roleId})
                   .trigger('getRoleList')
          `,

          this.updateRoleAuth && `@text: 分配权限
           @click:
              $form("updateRoleAuth", $this.row = $row);
              getRoleAuthListByProject({roleId:$row.roleId})
              .getRoleAuthList({roleId:$row.roleId})
                .trigger(async res=>{
                  Myformdata.authListString = res + '';
                  await window.sleep(100);

                  const tree = $refs.ElTree, isx = [];
                  /*_error(tree.getNode(67).childNodes.find(v=>v.data.authId));*/
                  forLoop(res=res.data.data||[],(v,c)=>{
                    if( v.authType != 2 && !v.children && (c=(tree.getNode(v.authId)||0).childNodes||[]).length !== 0 ) {
                      /*_error(c);*/
                      tree.setChecked(isx.put(c[0].data.authId),true);
                      return;
                    };
                    tree.setChecked(v.authId,true);
                  });
                  if( isx.length !== 0 ) {
                    tree.checkStrictly = true;
                    await $nextTick();
                    for( res of isx ) tree.setChecked(res,false);
                    await $nextTick();
                    tree.checkStrictly = false;
                  };

                });
          `,

        ],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getRoleList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/User/RoleManage.vue